<template>
<div class="pp-navbar__search">
    <div class="pp-varbar__search__icon">
        <i class="fa fa-fw fa-search"></i>
    </div>
    <input v-model="query" @keydown="onKeyDown" class="pp-navbar__search__input" type="text"
            :placeholder="view == 'mobile' ? 'Search for albums or tracks' : 'Search for albums or tracks by title, composer, ensemble, artist, or code'">
</div>
</template>


<script>
export default {
    name: 'nav-bar-search',
    data() {
        return {
            query: '',
        };
    },
    props: {
        view: String
    },
    watch: {
        '$route': 'fetchData'
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.query = this.$route.query.q;
        },

        search() {
            if (!this.query.trim()) {
                this.$router.push({
                    path: '/search',
                    query: {
                        q: ''
                    }
                })
                return;
            }

            this.$router.push({
                path: '/search',
                query: {
                    q: this.query.trim()
                }
            });
        },

        onKeyDown(e) {
            if (e.which == 13) {
                this.search();
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// NavBarSearch.vue?58b870c6